document.addEventListener('DOMContentLoaded', function () {
  const currentCustomerTagsElement = document.getElementById('krf-customer-tags');

  if (currentCustomerTagsElement) {
    const currentCustomerTags = currentCustomerTagsElement.value.trim();

    if (currentCustomerTags) {
      const pageRouteCustomerTagMap = {
        'le pépin voyageur': 'le-pepin-voyageur',
        'le raisin vif': 'le-raisin-vif',
        'le cep tranquille': 'le-cep-tranquille',
        'la vrille curieuse': 'la-vrille-curieuse',
        'la grappe joyeuse': 'la-grappe-joyeuse',
      };

      const customerTagKeys = Object.keys(pageRouteCustomerTagMap).map(tag => tag.toLowerCase());
      const customerTagsArray = currentCustomerTags.split(',').map(tag => tag.trim().toLowerCase());

      const customerTag = customerTagsArray.find(tag => customerTagKeys.includes(tag));
      const wineProfilePath = customerTag ? pageRouteCustomerTagMap[customerTag] : null;

      const hasLessThan35Tag = customerTagsArray.some(tag => !isNaN(tag) && Number(tag) < 35);

      // Detecta el prefijo de idioma actual, ej. "/de", "/en", o "" si es el default (fr)
      const localeMatch = window.location.pathname.match(/^\/(de|en)(?=\/|$)/);
      const localePrefix = localeMatch ? `/${localeMatch[1]}` : '';

      if (wineProfilePath) {
        let finalPath = `${localePrefix}/pages/${wineProfilePath}-v1`;

        if (!hasLessThan35Tag) {
          finalPath = `${localePrefix}/pages/${wineProfilePath}-v2`;
        }

        if (window.location.pathname !== finalPath) {
          window.location.href = finalPath;
        }
      } else {
        const defaultPath = `${localePrefix}/pages/wine-profile-not-found`;
        if (window.location.pathname !== defaultPath) {
          window.location.href = defaultPath;
        }
      }
    }
  }
});